/* Copyright (c) 2017 Backpack Health LLC */

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import ForgotPassword from '../views/ForgotPassword';

import { updateEmail, selectors } from '../../redux/ducks/user';

import RouteNames from '../../appAuthorized/RouteNames';
import { navigateBack, navigate } from '../../appAuthorized/redux/NavigationActions';

function mapStateToProps(state) {
  return {
    email: selectors.getEmail(state),
    goBack: () => {
      navigateBack(RouteNames.login());
    },
    goToCheckInbox: () => {
      navigate(RouteNames.forgotPasswordSent());
    },
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    updateEmail,
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(ForgotPassword);
